import { Record } from 'immutable';
import { Base } from './base';
import { omit } from 'lodash';

class Deal extends Base(Record({
    id: null,
    post_id: null,
    restrictions: [],
    quantity: 100,
    sold: 0,
    purchase_quantity: 1,
    expiration: 30,
    max_per_user: 1,
    value_amount: 100,
    paid_amount: 0,
    donation: 0,
    recipient: null,
    voucher_codes: [],
    inserted_at: null
  })) {
    $create(id) {
      if (this.id && this.state.entities.get('deals').get(this.id).isSuperset(this)) {
        return Promise.resolve(null);
      }

      return this.api.post({
          resource: 'deals'
        }, this.api.payload('deals', id ? omit(this.set('post_id', id).toJS(), ['sold']) : omit(this.toJS(), ['sold'])));
    }

    $delete() {
      return this.api.delete({
        id: this.id,
        resource: 'deals'
      });
    }

    $get(id, showAll) {
      if (this.post_id) id = this.post_id;

      let showFilter;
      if (!id) return Promise.resolve(null);
      showAll ? showFilter = '&filter[show]=all' : showFilter = '';

      this.dispatch(this.actions.clearEntities('deals'));

      return this.api.get({
        resource: 'deals?filter[post_id]=' + id + showFilter
      })
      .then(res => this.dispatch(this.actions.receiveEntities(res.data, 'deals')));
    }

    $put() {
      return this.api.patch({
        id: this.id,
        resource: 'deals'
      }, this.api.payload('deals', this));
    }

    post(state) {
      if (!state) state = this.state.entities;

      return state
        .get('posts')
        .get(this.post_id);
    }

    merchant() {
      return this.state.entities
        .get('merchant')
        .find(m => m.vendor_id === this.post().vendor_id)
    }

    voucherMerchant() {
      return this.state.entities
        .get('user')
        .get('merchant')
        .find(m => m.vendor_id === this.post(this.state.entities.get('user')).vendor_id)
    }

    get value() {
      return this.value_amount / 100;
    }

    get paid() {
      return this.paid_amount / 100;
    }

    get soldOut() {
      return this.quantity <= this.sold;
    }
  }

export default Deal;



// WEBPACK FOOTER //
// ./src/records/deal.js